import './App.css';
import Home from './pages/home/Home';
import Single from './pages/single/Single';
import Settings from './pages/settings/Settings';
import Bookmark from './pages/bookmark/Bookmark';
import Write from './pages/write/Write';
import Register from './pages/register/Register';
import Login from './pages/login/Login';
import Admin from './pages/admin/Admin'
import CreateCategory from './pages/createcategory/CreateCategory';
import SingleCategory from './pages/singlecategory/SingleCategory';

import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import { useContext } from "react";
import { Context } from "./context/Context";
import Categories from './pages/categories/Categories';
import Users from './pages/users/Users';
import SingleUser from './pages/singleuser/SingleUser';

function App() {  
  const {user} = useContext(Context);    
  return (
    <Router>

      <Switch>
        <Route exact path="/"> <Home/> </Route>
        <Route path="/settings"> {user ? <Settings/> : <Login/> } </Route>
        <Route path="/bookmarks"> {user ? <Bookmark/> : <Login/> } </Route>
        <Route path="/register"> {user ? <Home/> :  <Register/> } </Route>
        <Route path="/write"> {user ? <Write/> : <Login/> }  </Route>
        <Route path="/login"> {user ? <Home/> :  <Login/> } </Route>
        <Route path="/posts/:postId"> <Single/> </Route>
      </Switch>   

      <Switch>
       <Route exact path="/admin"> { user && (user.role === "masterAdmin") ? <Admin/> : <Login/> } </Route>
       <Route exact path="/admin/categories"> { user && (user.role === "masterAdmin") ? <Categories/> : <Login/> } </Route>
       <Route exact path="/admin/users"> { user && (user.role === "masterAdmin") ? <Users/> : <Login/> } </Route>
       <Route path="/admin/category/create"> { user && (user.role === "masterAdmin") ? <CreateCategory/> : <Login/> } </Route>
       <Route path="/admin/categories/:catId">{ user && (user.role === "masterAdmin") ? <SingleCategory/> : <Login/> } </Route>
       <Route path="/admin/users/:catId">{ user && (user.role === "masterAdmin") ? <SingleUser/> : <Login/> } </Route>
      </Switch> 
    </Router>

  );
}

export default App;
